export { default as feedReducer } from './feed.reducer'
